import classes from './home.module.css'
import { HeroSection, NextSection } from './homeComponent'



export function Home() {
    return (
        <div className={classes.parent}>
            <HeroSection />
            <NextSection />
           
        </div>
    )
}